import {NavLink} from 'react-router-dom';
import React, {useRef, useState} from "react";
import './signIn.css'
import Header from "../header/header";

function SignIn() {
    let [type, setType] = useState("password")
    let loginVal = useRef(null)
    let passVal = useRef(null)
    let loginErr = useRef(null)
    let user = {
        login: 'admin',
        password: 'admin'
    }

    function login() {
        if (user.login === loginVal.current.value && user.password === passVal.current.value) {
            window.location.href = '/userList';
        } else {
            loginErr.current.style.display = "block";
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }
    }

    return (
        <div className='signIn-block'>
            <form action="">
                <input type="text" placeholder='Login' ref={loginVal}/>
                <input type="password" placeholder='password' ref={passVal}/>
                <span className="err" ref={loginErr}>Մուտքանունը կամ գաղտնաբառը սխալ է</span>
                <button onClick={(e => {
                    e.preventDefault();
                    login();
                })}>Մուտք
                </button>
            </form>
        </div>
    );
}

export default SignIn;
